import React, { useCallback, useState } from "react";
import { api } from "./api.js";

export default function Verification({ onVerified, visitCount, maxVisits, initialChallenge }) {
  const [challenge, setChallenge] = useState(initialChallenge);
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const refreshChallenge = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const result = await api.refreshChallenge();
      setChallenge(result.challenge);
      setInput("");
      if (!result.required) onVerified();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [onVerified]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const answer = Number.parseInt(input, 10);
    if (Number.isNaN(answer)) return setError("请输入有效答案");
    if (!challenge?.id) return setError("验证题已失效，请换一题");

    setLoading(true);
    setError("");
    try {
      await api.verifyChallenge(challenge.id, answer);
      onVerified();
    } catch (err) {
      setError(err.message);
      if (err.details?.challenge) setChallenge(err.details.challenge);
      setInput("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verification-overlay">
      <div className="verification-card" role="dialog" aria-labelledby="verification-title" aria-modal="true">
        <div className="verification-header">
          <div className="verification-shield" aria-hidden="true">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></svg>
          </div>
          <h2 id="verification-title">访问验证</h2>
          <p>当前网络一小时内已访问 {visitCount || "多"} 次，超过 {maxVisits || 5} 次阈值，请完成验证后继续。</p>
        </div>

        <form className="verification-form" onSubmit={handleSubmit}>
          <div className="verification-challenge"><span className="challenge-label">请计算：</span><span className="challenge-expression">{challenge?.expression || "正在加载"}</span><span className="challenge-equals">= ?</span></div>
          <div className="verification-input-row">
            <input type="text" inputMode="numeric" className={`verification-input${error ? " input-error" : ""}`} placeholder="输入答案" value={input} onChange={event => { setInput(event.target.value.replace(/[^0-9-]/g, "")); setError(""); }} autoFocus disabled={loading} aria-invalid={Boolean(error)} />
            <button type="submit" className={`verification-submit${loading ? " btn-loading" : ""}`} disabled={loading || !input}>{loading ? "验证中..." : "确认"}</button>
          </div>
          {error && <p className="verification-error" role="alert">{error}</p>}
          <button type="button" className="verification-refresh" onClick={refreshChallenge} disabled={loading}>换一题</button>
        </form>
        <p className="verification-footer">验证题由服务端生成并校验，用于限制异常高频访问</p>
      </div>
    </div>
  );
}
